var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('a',{on:{"click":function($event){return _vm.handleClick()}}},[_vm._v(" "+_vm._s(_vm.translations["product.printerfriendly"])+" "),_c('span',{staticClass:"icon-print"})])])}
var staticRenderFns = []

export { render, staticRenderFns }